import { defineStore } from 'pinia'
import { ref } from 'vue'

export type NotificationType = 'success' | 'error' | 'warning' | 'info'

export interface Notification {
  show: boolean
  type: NotificationType
  message: string
  duration?: number
}

export const useAppStore = defineStore('app', () => {
  const loading = ref(false)
  const notification = ref<Notification>({
    show: false,
    type: 'info',
    message: '',
    duration: 5000
  })

  const setLoading = (value: boolean) => {
    loading.value = value
  }

  const showNotification = (type: NotificationType, message: string, duration = 5000) => {
    notification.value = {
      show: true,
      type,
      message,
      duration
    }

    // Auto close notification
    setTimeout(() => {
      clearNotification()
    }, duration)
  }

  const clearNotification = () => {
    notification.value.show = false
  }

  const showSuccess = (message: string) => {
    showNotification('success', message)
  }

  const showError = (message: string) => {
    showNotification('error', message)
  }

  const showWarning = (message: string) => {
    showNotification('warning', message)
  }

  const showInfo = (message: string) => {
    showNotification('info', message)
  }

  return {
    loading,
    notification,
    setLoading,
    showNotification,
    clearNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
})